module.exports = __webpack_public_path__ + "static/assets/7ab23a6df65da9d1bfdb825aa9307686.gif";